export const GALLERY_SIZE = 24
